import React from 'react'
import {
  fetchAnalysisCourtesyStatus,
  type AnalysisCourtesyStatus,
} from '../services/analysisCourtesyService'

export function useAnalysisCourtesyStatus(enabled: boolean) {
  const [status, setStatus] = React.useState<AnalysisCourtesyStatus | null>(null)
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const load = React.useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const next = await fetchAnalysisCourtesyStatus()
      setStatus(next)
    } catch (e: any) {
      setStatus(null)
      setError(e?.message || 'Falha ao carregar cortesia')
    } finally {
      setLoading(false)
    }
  }, [])

  React.useEffect(() => {
    if (!enabled) {
      setStatus(null)
      setLoading(false)
      setError(null)
      return
    }

    let mounted = true
    setLoading(true)
    setError(null)

    fetchAnalysisCourtesyStatus()
      .then((next) => {
        if (!mounted) return
        setStatus(next)
      })
      .catch((e: any) => {
        if (!mounted) return
        setStatus(null)
        setError(e?.message || 'Falha ao carregar cortesia')
      })
      .finally(() => {
        if (!mounted) return
        setLoading(false)
      })

    return () => {
      mounted = false
    }
  }, [enabled])

  return { status, loading, error, reload: load }
}
